import FundIcon from '@material-ui/icons/AccountBalance';
import FundFamilyList from './FundFamilyList';
import FundFamilyCreate from './FundFamilyCreate';
import FundFamilyEdit from './FundFamilyEdit';

export default {
  list: FundFamilyList,
  create: FundFamilyCreate,
  edit: FundFamilyEdit,
  icon: FundIcon
};
